import { render } from "./DeviceAddDetail.vue?vue&type=template&id=87921b6a&scoped=true"
import script from "./DeviceAddDetail.vue?vue&type=script&lang=js"
export * from "./DeviceAddDetail.vue?vue&type=script&lang=js"

import "./DeviceAddDetail.vue?vue&type=style&index=0&id=87921b6a&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87921b6a"]])

export default __exports__